import { PMSLocation } from "../_models/PMSLocation";
import { DeviceMapper } from "../../Everou/_mappers";
import { PMSReservationMapper } from "./PMSReservationMapper";

export class PMSLocationsMapper {
    static mapAllServerToLocal(serverPMSLocations = []) {
        return serverPMSLocations.map(this.mapServerToLocal);
    }

    static mapServerToLocal(
        {
            uid,
            loc_id,
            name,
            timezone,
            allows_customization,
            protect_without_subscription,
            protect,
            reservations,
            has_active_reservation,
            has_wifi_devices,
            has_disconnected_devices,
            has_lock_devices,
            device_battery,
            tags,
            vacation_rental_plan,
            url_recommendations,
            traveler_discount,
            external_video_url,
            has_integration,
            has_integration_error,
            pending_early_checkin_count,
            organization_name,
            organization_uid,
            permission_type,
        }
    ) {
        return PMSLocation({
            uid,
            id: loc_id,
            name,
            timezone,
            customization: allows_customization,
            protect: protect_without_subscription,
            protectStatus: protect,
            reservations: reservations,
            hasActiveReservation: has_active_reservation,
            hasWifiDevices: has_wifi_devices,
            hasDisconnectedDevices: has_disconnected_devices,
            hasLockDevices: has_lock_devices,
            deviceBattery: device_battery,
            tags: tags.map(tag => tag.tag),
            vacationRentalPlan: vacation_rental_plan,
            urlRecommendations: url_recommendations,
            travelerDiscount: traveler_discount,
            externalVideoUrl: external_video_url,
            hasIntegration: has_integration,
            hasIntegrationError: has_integration_error,
            pendingEarlyCheckinCount: pending_early_checkin_count ?? 0,
            organizationName: organization_name,
            organizationUid: organization_uid,
            permissionType: permission_type,
        });
    }
}

